import { Cake, User, Phone } from "lucide-react";
import { IconLabel } from "@/components/ui/IconLabel";
import { formatDate } from "@/lib/time";
import { Patient } from "../types";
import { formatPhone } from "@/lib/string";
import { Skeleton, SkeletonProps } from "@/components/ui/Skeleton";
import { twMerge } from "tailwind-merge";
import { CopyMrnButton } from "./CopyMrnButton";

interface PatientMetaProps {
  patient: Pick<Patient, "dateOfBirth" | "mrn" | "phone">;
}

export function PatientMeta({ patient }: PatientMetaProps) {
  return (
    <span className="text-content-muted flex flex-wrap items-center gap-2 text-xs font-medium">
      {patient.dateOfBirth && (
        <IconLabel icon={Cake}>{formatDate(patient.dateOfBirth)}</IconLabel>
      )}
      <span className="inline-flex items-center gap-1">
        <IconLabel icon={User} className="tabular-nums">
          {patient.mrn}
        </IconLabel>
        <CopyMrnButton mrn={patient.mrn} />
      </span>
      {patient.phone && (
        <IconLabel icon={Phone}>{formatPhone(patient.phone)}</IconLabel>
      )}
    </span>
  );
}

export function PatientMetaSkeleton({
  className,
  active = true,
  ...props
}: SkeletonProps) {
  return (
    <Skeleton
      {...props}
      active={active}
      className={twMerge("h-[18px] w-[280px]", className)}
    />
  );
}
